<mat-card class="training-documentation__card">
  <mat-icon id="formationDocumentationPDFIcon" [class]="class"></mat-icon>
  <div class="training-documentation__card-text">
    <mat-label>{{ title | translate }}</mat-label>
    <mat-label>{{ size }}</mat-label>
  </div>
  <div class="training-documentation__card-actions">
    <button id="formationDocumentationDownlaodButton" mat-stroked-button color="accent" (click)="downloadFile()">
      <mat-icon class="icon-ic_file_download"></mat-icon>
    </button>
    <button id="formationDocumentationDownlaodButton" mat-stroked-button (click)="viewFile()">
      <mat-icon class="icon-ic_visibility"></mat-icon>
    </button>
  </div>
</mat-card>
